'use client'

import React from 'react'
import styles from './not-found.module.scss'

const toHomePage = () => {
  window.open('/')
}

const NotFound = () => (
  <div className={styles.main}>
    <div className={styles.sorryText}>
      <div>404</div>
      <div>We couldn’t find this page.</div>
    </div>
    <h2 className={styles.infoText}>
      Take me back to <span onClick={toHomePage}>ackodrive.com</span>
    </h2>
  </div>
)

export default NotFound
